<div
  class="drawer-overlay"
  (click)="close()">
</div>


<aside class="cart-drawer">

  <!-- CHALDAL STYLE SIDE ARROW -->

  <button
    type="button"
    class="drawer-arrow"
    (click)="close()"
    aria-label="Close cart">

    ❯

  </button>


<div class="mobile-cart-header">

  <div class="save-bar">
    {{ t('shopMoreSaveFee') }}
  </div>

  <div class="cart-header">

    <button
      class="back-btn"
      (click)="close()">

      <i class="fa-solid fa-chevron-left"></i>

    </button>

    <div class="cart-title">

      <h3>{{ cart.count() }} {{ t('itemSingular') }}</h3>

      <span>{{ t('shippingFeeColon') }} {{ 59 | bnNumber:'৳' }}</span>

    </div>

    <i class="fa-solid fa-bag-shopping bag-icon"></i>

  </div>

</div>


  <!-- DESKTOP HEADER (চাল ডালের মতো "X items" + shipping fee bar) -->

  <div
    class="desktop-cart-header"
    *ngIf="cart.getItems().length > 0">

    <div class="desktop-cart-title">
      <i class="fa-solid fa-bag-shopping"></i>
      <h3>{{ cart.count() }} {{ t('itemSingular') }}</h3>
    </div>

    <span class="desktop-shipping-fee">
      {{ t('shippingFeeColon') }} {{ 59 | bnNumber:'৳' }}
    </span>

  </div>


  <!-- BODY -->

  <div class="drawer-body">


    <!-- EMPTY CART -->

    <div
      class="empty-cart"
      *ngIf="cart.getItems().length === 0">

      <div class="empty-icon">
        🛒
      </div>

      <h3>
        {{ t('yourCartIsEmpty') }}
      </h3>

      <p>
        {{ t('addedProductsAppearHere') }}
      </p>

    </div>


    <!-- CART ITEMS -->

    <div
      class="cart-items"
      *ngIf="cart.getItems().length > 0">


      <!-- SINGLE ITEM -->

      <div
        class="cart-item"
        *ngFor="let item of cart.getItems()">


        <!-- IMAGE -->

        <img
          class="item-image"

          [src]="
            getImage(
              item.imageUrl ||
              item.image_url
            )
          "

          (error)="onImgError($event)"

          alt="Product"
        />


        <!-- CENTER INFO -->

        <div class="item-info">

          <h3>
            {{ languageService.productName(item) }}
          </h3>


          <p
            class="item-unit"
            *ngIf="
              item.quantity &&
              item.unit
            ">

            {{ item.quantity | bnNumber }}
            {{ languageService.translateUnit(item.unit) }}

          </p>

        </div>


        <!-- RIGHT SIDE -->

        <div class="item-right">


          <!-- QUANTITY -->

          <div class="quantity-box">

            <button
              type="button"
              (click)="decreaseItem(item)">

              −

            </button>


            <span>
              {{ item.qty | bnNumber }}
            </span>


            <button
              type="button"
              (click)="increaseItem(item)">

              +

            </button>

          </div>


          <!-- PRICE + DELETE -->

          <div class="price-remove-row">


            <!-- PRICE -->

            <div class="item-price">

              {{ (item.price * item.qty) | bnNumber:'৳' }}

            </div>


            <!-- DELETE -->

            <button
              class="remove-btn"
              type="button"
              (click)="cart.remove(item)"
              [title]="t('removeItem')">

              <i class="fa-solid fa-trash"></i>

            </button>

          </div>

        </div>

      </div>

    </div>

  </div>


  <!-- FOOTER -->

  <div
    class="drawer-footer"
    *ngIf="cart.getItems().length > 0">

    <button
      class="checkout-btn"
      type="button"
      (click)="checkout()">


      <span>
        {{ t('checkout') }}
      </span>


      <span>
        {{ cart.getTotal() | bnNumber:'৳' }}
      </span>


    </button>

  </div>

</aside>